document.addEventListener("DOMContentLoaded", () => {
	const recipeCarousels = document.querySelectorAll(".recipe-carousel__swiper");

	if (recipeCarousels) {
		recipeCarousels.forEach((carousel) => {
			// Track carousel slides and center the carousel if there are only 2 slides
			const slideCount = carousel.querySelectorAll(".swiper-slide").length;
			if (slideCount == 2) {
				carousel.querySelector(".swiper-wrapper").classList.add("justify-content-center");
			}

			const swiper = new Swiper(carousel, {
				// Optional parameters
				keyboard: true,
				centeredSlides: slideCount == 1 ? true : false,
				breakpoints: {
					// when window width is >= 425px
					425: {
						slidesPerView: 1,
						spaceBetween: 20,
					},
					// when window width is >= 768px
					768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					// when window width is >= 992px
					992: {
						slidesPerView: 3,
						spaceBetween: 30,
					},
				},

				// Navigation and Pagination settings
				navigation: {
					nextEl: carousel.parentElement.querySelector(".recipe-carousel__swiper-navigation .swiper-button-next"),
					prevEl: carousel.parentElement.querySelector(".recipe-carousel__swiper-navigation .swiper-button-prev"),
				},
				pagination: {
					el: carousel.parentElement.querySelector(".recipe-carousel__swiper-pagination .swiper-pagination"),
					type: "fraction",
				},
			});
		});
	}
});
